import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { SearchService } from '@services/search.service';
import { CommonService } from '@services/common.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
import { rotateInDownLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-sbusiness',
  templateUrl: './sbusiness.component.html',
  styleUrls: ['./sbusiness.component.sass'],
  animations: [
    rotateInDownLeftOnEnterAnimation({ anchor: 'searchPage' })
  ]
})
export class SbusinessComponent implements OnInit {
  response: any = [];
  pageCounter = 1;
  totalRecord = 0;
  application = "business";
  component = 'b';
  rows = 1;
  params: any = [];
  total_record = 0;
  pageno = 1;
  sort = '';
  searchtxt = "";
  dataLoding = true;
  operation='';
  operations:any=[];
  constructor(private router: Router, private route: ActivatedRoute, private _commonService: CommonService,private _searchService: SearchService, private _global: GlobalService) {
    this.rows = this._global.ROWS;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    
    this.operation='create'+_.upperFirst(this.application);
    this.operations=this._global.api_doc(this.application,'operations');

    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      sortOrder: 'desc',
      sortString: 'createdTime',
      rows: this.rows
    };
    this.route.queryParams.subscribe(params => {
      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          p[key] = value;
        }
      });
    });

    this.loadAppData(p);
    let meta = {
      "title": this._global.SITE_TITLE,
      "description": this._global.DESCRIPTION
    };
    this._global.addMetaInfo(meta, '', 'title');

  }

  ngOnInit() {
  }
  loadAppData(p) {
    this.total_record = 0;
    this.response = [];
    this.dataLoding = true;
    this._searchService.application(p).subscribe(
      data => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.params = this._global.getVal(data, 'request', '');
          this.response = data["response"]["docs"];
          this.total_record = this._global.getVal(data, 'response.numFound', '0');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  getSort(value) {
    this.dataLoding = true;
    let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
    p['name'] = this.searchtxt;
    p['sortString'] = 'name';
    p['sortOrder']= value;
    this.loadAppData(p);
  }

  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.total_record <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._searchService.application(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.response = this.response.concat(data["response"]["docs"]);
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
        //  console.log('scrolled down!!', ev);

      }
    }
  }

  searchMedia(event: any) {
    let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
    p['name'] = this.searchtxt;
    this.loadAppData(p);
  }
}